import { gql } from 'apollo-angular';
import { buildConnectionQuery } from "../../../helpers.class";

export const nodeFragment = `
    id
    name
`;

export const emailTypeQuery = gql`${buildConnectionQuery("EmailType", "emailTypeConnection", nodeFragment)}`;